import { render, staticRenderFns } from "./produceEdit.vue?vue&type=template&id=3bad97f2&scoped=true&"
import script from "./produceEdit.vue?vue&type=script&lang=js&"
export * from "./produceEdit.vue?vue&type=script&lang=js&"
import style0 from "./produceEdit.vue?vue&type=style&index=0&id=3bad97f2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad97f2",
  null
  
)

export default component.exports